import { z } from 'zod'

const platformVersionConfigSchema = z.object({
  minSupportedVersion: z.string(),
  recommendedVersion: z.string(),
})

export const versionConfigResponseSchema = z.object({
  ios: platformVersionConfigSchema,
  android: platformVersionConfigSchema,
})

export type VersionConfigResponse = z.infer<typeof versionConfigResponseSchema>
